import {
  MultiSelect,
  type MultiSelectOption,
  type MultiSelectProps,
} from './MultiSelect'

export type AdaptiveMultiSelectFilterOption<T extends string | number> = MultiSelectOption<T>

export type AdaptiveMultiSelectFilterProps<T extends string | number> = {
  label: string
  options: AdaptiveMultiSelectFilterOption<T>[]
  selectedValues: T[]
  onChange: (next: T[]) => void
  ariaLabel?: string
  placeholder?: string
  emptyLabel?: string
  searchPlaceholder?: string
  searchable?: boolean
  collapseMode?: 'auto' | 'chips' | 'dropdown'
  forceCollapsed?: boolean
  className?: string
  summaryLabel?: string
  selectedSummaryMode?: 'count' | 'inline-truncated'
  size?: 'sm' | 'md'
}

export const AdaptiveMultiSelectFilter = <T extends string | number>(
  props: AdaptiveMultiSelectFilterProps<T>,
) => {
  return <MultiSelect<T> use="filter" {...(props as MultiSelectProps<T>)} />
}
